'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { theme } from '@/lib/ui/theme';

interface OutcomeSectionProps {
  isLoading?: boolean;
}

export function OutcomeSection({ isLoading = false }: OutcomeSectionProps) {
  if (isLoading) {
    return (
      <section className="px-6 py-12 md:px-16 md:py-16">
        <div className="mx-auto max-w-[800px] text-center">
          <Skeleton className="mx-auto mb-6 h-10 w-[70%]" />
          <Skeleton className="mx-auto mb-3 h-6 w-[80%]" />
          <Skeleton className="mx-auto h-6 w-[55%]" />
        </div>
      </section>
    );
  }

  return (
    <section className="px-6 py-12 md:px-16 md:py-16">
      <div className="mx-auto max-w-[800px] text-center">
        <h2
          className="text-gradient-hero mb-6 text-3xl font-bold tracking-tight md:text-4xl"
          style={{ fontFamily: theme.fonts.display }}
        >
          Ship at AI speed. Trust what merges.
        </h2>
        <p
          className="text-foreground/80 mx-auto max-w-[640px] text-base md:text-lg"
          style={{ fontFamily: theme.fonts.body }}
        >
          Keep the velocity your agents give you without treating a green build
          as proof. Mindrealm checks the code before it merges.
        </p>
      </div>
    </section>
  );
}
